import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BackButton, CustomTab } from 'components';
import { Box, Grid } from '@mui/material';

const CredsProductTabScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { current, providerCredSelected } = useSelector(store => store.providers)
  return (
    <Box mt={-2}>
      {/* <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate([
            '/admin/proveedores/creds/productos/pds',
            '/admin/proveedores/creds/productos/pin'
          ].includes(location.pathname) ? '..' : -1)} />
        </div>
        <div className="container-title">
          <div className="commerce">{providerCredSelected.conciliacion_service}</div>
          <div className="bag">{providerCredSelected.name_connector} </div>
        </div>
        <div>
        </div>
      </Grid> */}
      <CustomTab
        panels={[
          current.type === 'RECHARGE' && {
            name: "Recargas Celular",
            route: '/admin/proveedores/creds/productos/tae',
            onChange: () => navigate('tae'),
            content: <Outlet />
          },
          current.type === 'SERVICE' && {
            name: "Pago de Servicios",
            route: '/admin/proveedores/creds/productos/pds',
            onChange: () => navigate('pds'),
            content: <Outlet />
          },
          current.type === 'SERVICE' && {
            name: "Tarjetas de Regalo",
            route: '/admin/proveedores/creds/productos/pin',
            onChange: () => navigate('pin'),
            content: <Outlet />
          }
        ].filter(Boolean)}
      />
    </Box>
  );
}

export default CredsProductTabScreen